import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { normalizeReportStatus } from '@/lib/reportStatus';
import { SendStatusBadge } from '@/pages/reports/list/components/SendStatusBadge';
import type { ReportStatus } from '@/types/reports';

interface SendReportHeaderProps {
  title: string;
  reportDate: string;
  partnerLabel: string;
  status?: ReportStatus;
  onBack: () => void;
  children?: React.ReactNode;
}

export const SendReportHeader: React.FC<SendReportHeaderProps> = ({
  title,
  reportDate,
  partnerLabel,
  status,
  onBack,
  children,
}) => {
  const reportStatus = normalizeReportStatus(status);

  return (
    <header className="flex w-full flex-col items-start gap-0.5">
      <button
        type="button"
        onClick={onBack}
        className="flex h-9 items-center justify-center gap-2 rounded-lg px-6 text-sm font-medium leading-5 text-[#171717] hover:bg-gray-50"
      >
        <ArrowLeft className="h-4 w-4 shrink-0" strokeWidth={1.33} aria-hidden />
        Voltar
      </button>

      <div className="flex w-full flex-col items-start px-6">
        <div className="flex w-full flex-col items-start gap-2 pb-5">
          <h1 className="w-full text-2xl font-bold leading-8 text-[#0A0A0A]">
            {title}
          </h1>
          <div className="flex w-full flex-wrap items-center gap-2">
            <span className="font-sans text-base font-normal leading-6 text-[#737373]">
              Report {reportDate}
            </span>
            <div className="flex items-start gap-2">
              <Badge className="inline-flex h-5 items-center justify-center gap-1 rounded-lg border-transparent bg-[#171717] px-2 py-0.5 text-xs font-semibold leading-4 text-[#FAFAFA] hover:bg-[#171717]">
                {partnerLabel}
              </Badge>
              <SendStatusBadge status={reportStatus} />
            </div>
          </div>
        </div>

        <div className="h-px w-full bg-[#E5E5E5]" />
        {children}
        <div className="h-px w-full bg-[#E5E5E5]" />
      </div>
    </header>
  );
};
